<template>
  <section class="whiteboard-section d-flex flex-column">
    <div class="whiteboard-header-tools d-flex align-items-center">
      <div class="container d-flex justify-content-between align-items-center px-0">
        <div v-if="!isMobile" class="whiteboard-title">
          <div v-if="!enableWhiteboardTitle" class="d-flex flex-column">
            <div style="display: flex; align-items: center;">
              <span class="title">{{ getSelectedBook.book.title }}</span>
              &nbsp;
              &nbsp;
              <span class="material-icons-sharp edit" @click="editTitle">
                edit
              </span>
            </div>
            <div v-if="bookTitleError" id="book-title-error" class="form-text error d-flex align-items-center">
              <span class="text-danger">No mínimo 4 caracteres</span>
            </div>
          </div>
          <div v-else>
            <div style="display: flex; align-items: center;">
              <input id="book-title" type="text" :value="copyTitle">
              &nbsp;
              &nbsp;
              <span class="material-symbols-outlined done" @click="saveTitle">
                done
              </span>
            </div>
          </div>
        </div>
        <div v-if="!isBookPdf()" class="d-flex w-100 justify-content-between align-items-center" style="padding: 0 10px !important;">
          <div v-if="isMobile" class="whiteboard-title">
            <div v-if="!enableWhiteboardTitle" class="d-flex flex-column">
              <div style="display: flex; align-items: center; min-width: 200px;">
                <span class="title">{{ getSelectedBook.book.title }}</span>
                &nbsp;
                &nbsp;
                <span class="material-icons-sharp edit" @click="editTitle">
                  edit
                </span>
              </div>
              <div v-if="bookTitleError" id="book-title-error" class="form-text error d-flex align-items-center">
                <span class="text-danger">No mínimo 4 caracteres</span>
              </div>
            </div>
            <div v-else>
              <div style="display: flex; align-items: center;">
                <input id="book-title" type="text" :value="copyTitle">
                &nbsp;
                &nbsp;
                <span class="material-symbols-outlined done" @click="saveTitle">
                  done
                </span>
              </div>
            </div>
          </div>
          <div class="undo-redo d-flex gap-3">
            <svg :class="{'active': canUndoSteps}"
                 xmlns="http://www.w3.org/2000/svg"
                 width="28"
                 height="28"
                 viewBox="0 0 28 28"
                 fill="none"
                 @click="undoStep">
              <path d="M8.16669 22.1667V20.4167H16.5959C17.957 20.4167 19.1285 19.9646 20.1104 19.0604C21.0924 18.1562 21.5834 17.0333 21.5834 15.6917C21.5834 14.35 21.0924 13.2271 20.1104 12.3229C19.1285 11.4187 17.957 10.9667 16.5959 10.9667H7.99169L11.3167 14.2917L10.0917 15.5167L4.66669 10.0917L10.0917 4.66666L11.3167 5.89166L7.99169 9.21666H16.5667C18.4139 9.21666 20.0035 9.83888 21.3354 11.0833C22.6674 12.3278 23.3334 13.8639 23.3334 15.6917C23.3334 17.5194 22.6674 19.0555 21.3354 20.3C20.0035 21.5444 18.4139 22.1667 16.5667 22.1667H8.16669Z"/>
            </svg>
            <svg :class="{'active': canRedoSteps}"
                 xmlns="http://www.w3.org/2000/svg"
                 width="28"
                 height="28"
                 viewBox="0 0 28 28"
                 fill="none"
                 @click="redoStep">
              <path d="M11.4334 22.1667C9.58613 22.1667 7.99655 21.5444 6.6646 20.3C5.33266 19.0555 4.66669 17.5194 4.66669 15.6917C4.66669 13.8639 5.33266 12.3278 6.6646 11.0833C7.99655 9.83888 9.58613 9.21666 11.4334 9.21666H20.0084L16.6834 5.89166L17.9084 4.66666L23.3334 10.0917L17.9084 15.5167L16.6834 14.2917L20.0084 10.9667H11.4042C10.0431 10.9667 8.87155 11.4187 7.8896 12.3229C6.90766 13.2271 6.41669 14.35 6.41669 15.6917C6.41669 17.0333 6.90766 18.1562 7.8896 19.0604C8.87155 19.9646 10.0431 20.4167 11.4042 20.4167H19.8334V22.1667H11.4334Z"/>
            </svg>
          </div>
          <div class="pages" v-if="!isMobile">
            <div class="dropdown">
                <span class="btn btn-secondary w-100 p-2" type="button" id="dropdownPage" data-bs-toggle="dropdown"
                      aria-expanded="false" @click="toggleMenu">
                  {{ selectedPage }}
                  <i v-if="dropdownPageToggle" class="bi bi-chevron-down float-right ms-1"></i>
                  <i v-if="!dropdownPageToggle" class="bi bi-chevron-up float-right ms-1"></i>
                </span>

              <ul class="dropdown-menu w-100" aria-labelledby="dropdownPage" data-bs-target="#dropdownPage"
                  aria-hidden="true">
                <li v-for="(page, idxPages) in pages" :key="idxPages">
                  <a class="dropdown-item" href="#" @click.prevent="selectPage(page)">
                    {{ page.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="export-options">

          <div class="dropdown">
              <span class="btn btn-secondary w-100 p-2 d-flex align-items-center gap-2" type="button" id="dropdownExport" data-bs-toggle="dropdown"
                    aria-expanded="false" @click="toggleMenu">
                <span class="material-symbols-outlined system_update_alt">
                  system_update_alt
                </span>
                <span v-if="!isMobile">
                  &nbsp;
                  Download
                </span>
              </span>

            <ul class="dropdown-menu w-100" aria-labelledby="dropdownExport" data-bs-target="#dropdownExport"
                aria-hidden="true">
              <li>
                <a class="dropdown-item" href="#" @click.prevent="exportBook('PNG')">
                  <span>{{ $i18n.t('lms.whiteboard.save_as')}}</span>
                  <span class="format"> PNG</span>
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="exportBook('PDF')">
                  <span>{{ $i18n.t('lms.whiteboard.save_as')}}</span>
                  <span class="format"> PDF</span>
                </a>
              </li>
            </ul>
          </div>



        </div>
        </div>

      </div>
    </div>

    <div v-if="isBookPdf()" class="container">

      <iframe id="whiteboard-pdf" width="100%" height="100%" :src="book.book.template.pdf_file.url" frameborder="0"></iframe>

    </div>

    <div v-else class="board d-flex w-100 justify-content-center align-items-center">
        <div class="toolbar" id="toolbar"></div>
        
        <div id="whiteboard" @click="whiteboardClick"></div>
        

      </div>

  </section>
</template>

<script>

import { mapGetters } from "vuex";
import {WhiteWebSdk } from "white-web-sdk";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import $ from 'jquery';
$;
let emitter = require('tiny-emitter/instance');
emitter;

export default {
  name: "Whiteboard",
  props: {
    template: {
      default: 0
    },
  },
  data(){
    return {
      initData: "",
      whiteWebSdk: "",
      joinRoomParams: "",
      whiteBoardRoom: "",
      conf: {
        audio: true,
        video: true,
        screen: false,
        whiteboard:{
          tools: ["selector","hand","laserPointer","pencil","ellipse","rectangle","straight","text","eraser","arrow","pallet",],
        }
      },
      tools: {
        selector:{
          name:"selector",
          text:"Ponteiro mouse padrão, sem efeito no board",
          image:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="42" height="42">
                <path fill="_fill" d="M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"/>
            </svg>`,
          title:"Selecionador"
        },
        hand:{
          name:"hand",
          text:"Mão controle de visualização do board",
          image:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="42" height="42">
                <path fill="_fill" d="M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"/>
            </svg>`,
          title:"Arrastar"
        },
        laserPointer:{
          name:"laserPointer",
          text:"Laser ponteiro do mouse estilo caneta laser",
          image:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" width="42" height="42">
                <path fill="_fill" d="M360 976q-46 0-78-32t-32-78q0-46 32-78t78-32q46 0 78 32t32 78q0 46-32 78t-78 32Zm169-132q-6-46-33.5-81.5T427 710l132-134H226q-29 0-47.5-23T160 500q0-18 9-33t24-24l498-300q14-9 30.5-4.5T746 157q8 14 4.5 30.5T733 212L314 466h420q27 0 46.5 19.5T800 532q0 17-4 32.5T781 591L529 844Z"/>
            </svg>`,
          title: "Laser"
        },
        pencil:{
          name:"pencil",
          text:"Lápis desenho livre no board",
          image:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="42" height="42">
            <path fill="_fill" d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"/>
        </svg>`,
          title: "Lápis"
        },
        ellipse:{
          name:"ellipse",
          text:"Elipse desenhe elipses no board",
          image:`<svg viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" width="42" height="42">
                <circle cx="18" cy="18.0703" r="15" fill="" stroke="_fill" stroke-width="6"/>
            </svg>`,
          title: "Elipse"
        },
        rectangle:{
          name:"rectangle",
          text:"Retângulo desenhe retângulos no board",
          image:`<svg width="42" height="42" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_3_12" fill="white">
                    <rect y="0.0703125" width="36" height="36" rx="4"/>
                </mask>
                <rect y="0.0703125" width="36" height="36" rx="4" stroke="_fill" stroke-width="12" mask="url(#path-1-inside-1_3_12)"/>
            </svg>`,
          title:"Retângulo"
        },
        straight:{
          name:"straight",
          text:"Linha desenhe linhas no board",
          image:`<svg width="42" height="42" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect fill="_fill" x="21" y="-0.929688" width="5.40755" height="36" rx="2.70377" transform="rotate(36.998 21 -0.929688)"/>
        </svg>`,
          title:"Linha"
        },
        text:{
          name:"text",
          text:"Texto adiciona texto ao board",
          image:`<svg width="42" height="42" viewBox="0 0 21 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="_fill" d="M10.232 26.0762C9.56 26.0762 9.008 25.8722 8.576 25.4642C8.144 25.0322 7.928 24.5042 7.928 23.8802V3.00017H12.608V23.8802C12.608 24.5042 12.38 25.0322 11.924 25.4642C11.492 25.8722 10.928 26.0762 10.232 26.0762ZM2.276 5.01617C1.652 5.01617 1.124 4.82417 0.692 4.44017C0.284 4.05617 0.08 3.55217 0.08 2.92817C0.08 2.30417 0.284 1.81217 0.692 1.45217C1.124 1.06817 1.652 0.87617 2.276 0.87617H18.26C18.884 0.87617 19.4 1.06817 19.808 1.45217C20.24 1.83617 20.456 2.34017 20.456 2.96417C20.456 3.58817 20.24 4.09217 19.808 4.47617C19.4 4.83617 18.884 5.01617 18.26 5.01617H2.276Z"/>
        </svg>`,
          title:"Adicionar Texto"
        },
        eraser:{
          name:"eraser",
          text:"Borracha apaga elementos do board",
          image:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="42" height="42">
            <path fill="_fill" d="M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"/>
        </svg>`,
          title: "Apagador"
        },
        arrow:{
          name:"arrow",
          text:"Seta adiciona seta no board",
          image:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="42" height="42">
            <path fill="_fill" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
        </svg>`,
          title: "Seta"
        },
        pallet:{
          name:"pallet",
          text:"Cor defina a cor ativa para desenho",
          image:`
        <svg width="42" height="42" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 0.564087C12.9375 0.564087 10.9922 0.962524 9.16406 1.7594C7.38281 2.5094 5.78906 3.58752 4.38281 4.99377C3.02344 6.35315 1.94531 7.9469 1.14844 9.77502C0.398438 11.5563 0.0234375 13.4781 0.0234375 15.5406C0.0234375 17.6031 0.398438 19.5485 1.14844 21.3766C1.94531 23.1578 3.02344 24.7516 4.38281 26.1578C5.78906 27.5172 7.38281 28.5953 9.16406 29.3922C10.9922 30.1422 12.9375 30.5172 15 30.5172C16.0312 30.5172 16.8984 30.1656 17.6016 29.4625C18.3516 28.7125 18.7266 27.8219 18.7266 26.7906C18.7266 25.8531 18.4219 25.0094 17.8125 24.2594C17.6719 24.1188 17.6016 23.9547 17.6016 23.7672C17.6016 23.5797 17.6719 23.4156 17.8125 23.275C17.9531 23.1344 18.1406 23.0641 18.375 23.0641H20.9766C22.6641 23.0641 24.1875 22.6656 25.5469 21.8688C26.9062 21.025 27.9844 19.9235 28.7812 18.5641C29.5781 17.2047 29.9766 15.7047 29.9766 14.0641C29.9766 12.1891 29.5781 10.4313 28.7812 8.79065C28.0312 7.15002 26.9531 5.72034 25.5469 4.50159C24.1875 3.28284 22.5938 2.3219 20.7656 1.61877C18.9844 0.915649 17.0625 0.564087 15 0.564087ZM23.2266 17.0172C22.6172 17.0172 22.0781 16.8063 21.6094 16.3844C21.1875 15.9625 20.9766 15.4235 20.9766 14.7672C20.9766 14.1578 21.1875 13.6422 21.6094 13.2203C22.0781 12.7516 22.6172 12.5172 23.2266 12.5172C23.8828 12.5172 24.4219 12.7516 24.8438 13.2203C25.2656 13.6422 25.4766 14.1578 25.4766 14.7672C25.4766 15.4235 25.2656 15.9625 24.8438 16.3844C24.4219 16.8063 23.8828 17.0172 23.2266 17.0172ZM18.7266 11.0406C18.1172 11.0406 17.5781 10.8297 17.1094 10.4078C16.6875 9.93909 16.4766 9.40002 16.4766 8.79065C16.4766 8.18127 16.6875 7.66565 17.1094 7.24377C17.5781 6.77502 18.1172 6.54065 18.7266 6.54065C19.3828 6.54065 19.9219 6.77502 20.3438 7.24377C20.7656 7.66565 20.9766 8.18127 20.9766 8.79065C20.9766 9.40002 20.7656 9.93909 20.3438 10.4078C19.9219 10.8297 19.3828 11.0406 18.7266 11.0406ZM4.52344 14.7672C4.52344 14.1578 4.73438 13.6422 5.15625 13.2203C5.57812 12.7516 6.11719 12.5172 6.77344 12.5172C7.38281 12.5172 7.89844 12.7516 8.32031 13.2203C8.78906 13.6422 9.02344 14.1578 9.02344 14.7672C9.02344 15.4235 8.78906 15.9625 8.32031 16.3844C7.89844 16.8063 7.38281 17.0172 6.77344 17.0172C6.11719 17.0172 5.57812 16.8063 5.15625 16.3844C4.73438 15.9625 4.52344 15.4235 4.52344 14.7672ZM13.5234 8.79065C13.5234 9.40002 13.2891 9.93909 12.8203 10.4078C12.3984 10.8297 11.8828 11.0406 11.2734 11.0406C10.6172 11.0406 10.0781 10.8297 9.65625 10.4078C9.23438 9.93909 9.02344 9.40002 9.02344 8.79065C9.02344 8.18127 9.23438 7.66565 9.65625 7.24377C10.0781 6.77502 10.6172 6.54065 11.2734 6.54065C11.8828 6.54065 12.3984 6.77502 12.8203 7.24377C13.2891 7.66565 13.5234 8.18127 13.5234 8.79065Z" fill="_fill"/>
        </svg>`,
          title: "Seletor de cor"
        },
        AddImage:{
          name:"AddImage",
          text:"Adcione uma imagem ao quadro",
          image:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="42" height="42">
            <path d="M9,42c-0.8,0-1.5-0.3-2.1-0.9C6.3,40.5,6,39.8,6,39V9c0-0.8,0.3-1.5,0.9-2.1S8.2,6,9,6h20.5v3H9v30h30V18.6h3 V39c0,0.8-0.3,1.5-0.9,2.1C40.5,41.7,39.8,42,39,42H9z M35,17.1v-4.1h-4v-3h4V6h3v4.1h4v3h-4v4.1H35z M12,33.9h24l-7.2-9.6l-6.4,8.4 l-4.7-6.2L12,33.9z M9,9v30V9z" fill="_fill"/>
        </svg>`,
          title: "Adicionar imagem"
        }
      },
      currentTool: "selector",
      book: null,
      enableWhiteboardTitle: false,
      bookTitleError: false,
      timerThumbnail: null,
      whiteboardUserClick: false,
      copyTitle: "",
      thumbnailDelayTime: 30000, // 30 segs
      pages: [],
      selectedPage: "",
      dropdownPageToggle: true,
      canUndoSteps: 0,
      canRedoSteps: 0,
      processingExport: false,
      isMobile: false,
    }
  },
  mounted() {

    let root_ = this;
    root_.isMobile = (root_.checkMobile || root_.checkIOS);
    root_.book = root_.getSelectedBook;

    if(root_.book === null) {
      return root_.$router.push({
        name: "LmsStudentBook",
        params: {
          lmsSlug: root_.$route.params.lmsSlug
        }
      })
    }
    root_.$parent.wait(true);

    root_.book = root_.getSelectedBook;

    if(root_.book.book.template === "em branco") {
      root_.book.book.template = {
        "configs": {
          "isPdf": false
        }
      }
    } else {
      if (typeof root_.book.book.template.configs === 'string') {
        root_.book.book.template.configs = JSON.parse(root_.book.book.template.configs);
      }
    }

    root_.copyTitle = root_.getSelectedBook.book.title;


    if(root_.book.book.template.configs.isPdf) {

      root_.$parent.wait(false);
      // Hack to make pdf input editable
      root_.$nextTick(() => {
       $("#whiteboard-pdf").click();
      });

    } else {

      root_.$store.dispatch("Whiteboard/initWhiteboard", root_.book)
          .then(data => {
            root_.initData = data;
            root_.startWhiteboard();
          })
          .catch(error => {
            console.error("Whiteboard: ", error);
          })
    }


  },
  methods: {
    
    isBookPdf() {
      return this.book?.book?.template?.configs?.isPdf;
    },
    whiteboardClick() {
      this.whiteboardUserClick = true;
    },
    exportBook(format) {

      let root_ = this;

      if(root_.processingExport){
        return;
      }
      root_.processingExport = true;
      root_.getWhiteboardImage()
          .then(canvas => {

            if(format === 'PDF') {
              const whiteboard = document.getElementsByClassName("netless-whiteboard")[0];

              const imgData = canvas.toDataURL('image/png');
              const pdf = new jsPDF('L', 'px', [whiteboard.offsetWidth, whiteboard.offsetHeight]);

              pdf.addImage(imgData, 'PNG', 0, 0, whiteboard.offsetWidth, whiteboard.offsetHeight);
              pdf.save(`${root_.copyTitle.replace(/\s/g, '_')}.pdf`);

            } else if(format === 'PNG') {

              const image = canvas.toDataURL('image/png');
              const a = document.createElement('a');
              a.setAttribute('download', `${root_.copyTitle.replace(/\s/g, '_')}.png`);
              a.setAttribute('href', image);
              a.setAttribute('target', '_blank');
              a.click();

            }
          })
          .finally(() => {
            root_.processingExport = false;
          });
    },
    getWhiteboardImage() {

      const whiteboard = document.getElementsByClassName("netless-whiteboard")[0];

      return html2canvas(whiteboard, {
        allowTaint: true,
        useCORS: true,
        width: whiteboard.offsetWidth,
        height: whiteboard.offsetHeight,
      })

    },
    startWhiteboard() {
      let root_ = this;

      root_.whiteWebSdk = new WhiteWebSdk({
        // Pass in your App Identifier.
        appIdentifier: root_.initData.whiteBoard.appIdentifier,
        // Set the data center as Silicon Valley, US.
        region: "us-sv",
      })

      root_.joinRoomParams = {
        uuid: root_.initData.whiteBoard.roomUuid,
        // The unique identifier of a user. If you use versions earlier than v2.15.0, do not add this line.
        uid: root_.initData.whiteBoard.uid,
        roomToken: root_.initData.whiteBoard.roomToken,
        cameraBound: {
          damping: 1,
          centerX: 0,          // Coordenada X do centro
          centerY: 0          // Coordenada Y do centro
        }
      };

      // Join the whiteboard room and display the whiteboard on the web page.
      root_.whiteWebSdk.joinRoom(root_.joinRoomParams)
          .then(function(room) {
            root_.whiteBoardRoom = room;
            root_.whiteBoardRoom.bindHtmlElement(document.getElementById("whiteboard"));
            root_.initializeRoom();
          })
          .catch(function(err) {
            console.error(err);
          })
          .finally(() => {
            // window.whiteWebSdk = root_.whiteWebSdk; // Use to debug
            // window.room = root_.whiteBoardRoom;     // Use to debug
            root_.$parent.wait(false);
          })

    },
    initializeRoom() {
      let root_ = this;


      root_.whiteBoardRoom.disableSerialization = false; // Allow undo/redo
      root_.disableCameraTransform = root_.book.book.template.configs.camLock;               // Zoom on/off


      root_.createToolBar();
      root_.setThumbnailInterval();

      // Ensure to delete /init page
      root_.whiteBoardRoom.removeScenes("/init")
      root_.pages = root_.whiteBoardRoom.getCurrentSceneState().scenes;


      if(root_.getBookCreatedNow) {
        root_.selectPage(root_.pages[0]);
      }

      root_.selectedPage = root_.whiteBoardRoom.getCurrentSceneState().sceneName;

      root_.whiteBoardRoom.callbacks.on("onCanUndoStepsUpdate", (function(t) {
        root_.canUndoSteps = t;
      }));

      root_.whiteBoardRoom.callbacks.on("onCanRedoStepsUpdate", (function(t) {
        root_.canRedoSteps = t;
      }));


    },
    createToolBar(){
      let root_ = this;

      if (!root_.whiteBoardRoom) return;

      let whiteboard = Object.keys(root_.tools);

      const toolbar = document.getElementById("toolbar");
      if (toolbar) {
        toolbar.innerHTML = '';
      }

      if (whiteboard.includes("pallet")) {

        const colorPicker = document.createElement('input');
        colorPicker.id = 'color-picker';
        colorPicker.type = 'color';

        let color = localStorage.getItem('color');
        if (!color) {
          color = '#' + Math.floor(Math.random() * 16777215).toString(16);
          localStorage.setItem('color', color);
        }

        if (colorPicker) {
          colorPicker.value = color;
        }

        // const colorPicker = document.getElementById('color-picker');
        if (colorPicker) {
          colorPicker.addEventListener('change', function() {
            localStorage.setItem('color', this.value);
            root_.setTool();
          });
        }

        if (toolbar) {
          toolbar.appendChild(colorPicker);
        }
      }
      whiteboard.forEach((t) => {
        const tool = root_.tools[t];

        let toggleBtn = document.querySelector(`#btn${t}Toggle`);
        if (!toggleBtn) {
          toggleBtn = document.createElement('div');
          toggleBtn.id = `btn${t}Toggle`;

        }


        if (root_.conf.whiteboard.tools.includes(t)) {
          toggleBtn.classList.add('selected');
          toggleBtn.innerHTML = `${tool.image.replace('_fill', 'var(--buttons_color)')}${tool.title}`;
          toggleBtn.style.color = 'var(--buttons_color)';
        } else {
          toggleBtn.innerHTML = `${tool.image.replace('_fill', '#C4C4C4')}${tool.title}`;
          toggleBtn.style.color = '#C4C4C4';
        }



        const btn = document.createElement('button');
        btn.className = 'whiteboard-tools';
        btn.title = tool.text;
        btn.id = `btn${tool.name}`;

        let html = tool.image.replace('_fill', '#C4C4C4');

        if (tool.name === root_.currentTool)
          html = tool.image.replace('_fill', 'var(--buttons_color)');
        if (tool.name === "pallet"){
          html += '<label for="color-picker" class="color-picker-label" id="color-picker-label"></label>';
        }else if (tool.name === "AddImage"){
          const input = document.createElement('input');
          input.type = 'file';
          input.id = 'inputAddImage';
          input.accept = 'image/*';
          input.style.display = 'none';

          input.addEventListener("change", function() {
            let file = this.files && this.files[0];
            if (file) {
              // Converta o arquivo em base64
              let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function() {
                // Encontre a largura e altura da imagem
                let img = new Image();
                img.src = reader.result;
                img.onload = function() {
                  let width = img.width;
                  let height = img.height;
                  // Largura e altura máximas
                  let maxWidth = 500;
                  let maxHeight = 500;
                  // Calcule a escala
                  let scale = Math.min(maxWidth / width, maxHeight / height);
                  // Calcule a nova largura e altura
                  width = width * scale;
                  height = height * scale;
                  let uuid = root_.genUUID();
                  // Insira a imagem
                  root_.whiteBoardRoom.insertImage({
                    uuid: uuid,
                    centerX: root_.whiteBoardRoom.mainView.camera.centerX,
                    centerY: root_.whiteBoardRoom.mainView.camera.centerY,
                    width,
                    height,
                    locked: false,
                    uniformScale: true,
                  });
                  // Complete o upload da imagem
                  root_.whiteBoardRoom.completeImageUpload(uuid, reader.result);
                  // Limpe o valor do input
                  input.value = "";
                };
              };
            }
          });

          toolbar.append(input);
        }
        if (tool.name === root_.currentTool) {
          btn.classList.add('selected');
        } else {
          btn.classList.remove('selected');
        }

        btn.innerHTML = html;

        btn.addEventListener("click", function() {
          let colorPicker = document.getElementById('color-picker');
          let inputAddImage = document.getElementById('inputAddImage');

          switch (tool.name) {
            case "pallet":
              // let colorPicker = document.getElementById('color-picker');
              if (colorPicker) {
                colorPicker.click();
              }
              break;
            case "AddImage":
              // let inputAddImage = document.getElementById('inputAddImage');
              if (inputAddImage) {
                inputAddImage.click();
              }
              break;
            default:
              root_.currentTool = tool.name;
              document.querySelectorAll(".whiteboard-tools").forEach(function(element) {
                let t = root_.tools[element.id.substring(3)];
                if (element.id !== btn.id && t) {
                  let html = t.image.replace('_fill', '#C4C4C4');

                  if (t.name === "pallet") {
                    html += '<label for="color-picker" class="color-picker-label" id="color-picker-label"></label>';
                  }

                  element.classList.remove('selected');
                  element.innerHTML = html;
                }
              });

              btn.classList.add('selected');
              btn.innerHTML = `${tool.image.replace('_fill', 'var(--buttons_color)')}`;

              root_.setTool();
              break;
          }
        });


        toolbar.append(btn);
      })
      root_.setTool();

    },
    setTool(){
      let root_ = this;

      let data = {
        currentApplianceName: root_.currentTool,
        shapeType: "pentagram",
        strokeWidth: 12,
        textSize: 40,
      }
      let currentCollor = document.getElementById('color-picker').value;

      if (currentCollor){
        const colorPickerLabel = document.getElementById('color-picker-label');
        if (colorPickerLabel) {
          colorPickerLabel.style.backgroundColor = currentCollor;
        }

      }else {
        currentCollor = localStorage.getItem('color');
      }
      if (currentCollor){
        data.strokeColor = root_.hexToRGB(currentCollor);
        data.textColor = root_.hexToRGB(currentCollor);
      }
      if (root_.whiteBoardRoom)
        root_.whiteBoardRoom.setMemberState(data);
    },
    genUUID(){
      let d = new Date().getTime();
      return 'xxxxyxxx-xxxx-4xxx-yxxx-xxxxxyxxyyyx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },
    hexToRGB(hex) {
      const r = parseInt(hex.slice(1, 3), 16),
          g = parseInt(hex.slice(3, 5), 16),
          b = parseInt(hex.slice(5, 7), 16);

      return [r,g,b];
    },
    editTitle() {
      this.enableWhiteboardTitle = true;
      this.bookTitleError = false;
    },
    saveTitle() {

      let root_ = this;

      this.enableWhiteboardTitle = false;

      let title = document.getElementById("book-title").value;

      if(title.length >= 4 && title !== this.getSelectedBook.book.title) {


        let book = root_.getSelectedBook;
        book.book.title = title;
        book.book.id = book.id;

        let payload = {
          "id": root_.getLms.id,
          "book": book.book
        }

        root_.$store.dispatch("Whiteboard/updateSelectedBook", payload)
            .then(book => {
              root_.copyTitle = book.title;
            });

      } else {
        this.bookTitleError = title.length < 4 && title.length !== 0;
      }

    },
    setThumbnailInterval() {
      let root_ = this;

      root_.timerThumbnail = setInterval(() => {

        if(root_.whiteboardUserClick) {
          root_.getWhiteboardImage()
              .then(image => {
                image = image.toDataURL('image/png');

                // Converter a string base64 em um array de bytes
                const arrayBuffer = root_.base64ToArrayBuffer(image);

                // Criar um objeto Blob
                const blob = new Blob([arrayBuffer], { type: "image/png" }); // Defina o tipo de acordo com o tipo da imagem



                let formData = new FormData();
                formData.append('file', blob);
                formData.append('key', 'LMS');
                formData.append('folder', 'LMS');


                let payload = {
                  "formData": formData
                }

                let book = root_.getSelectedBook;

                let payloadDelete = {
                  "ids": [book.book.thumbnail_file_id]
                }

                root_.$store.dispatch("FileManager/onFileUpload", payload)
                    .then(response => {

                      book.book.thumbnail_file_id = response.file_id;
                      book.book.thumbnail = response.thumbnail;
                      book.book.id = book.id;

                      if(payloadDelete.ids[0] !== undefined){
                        root_.$store.dispatch("FileManager/onFileDelete", payloadDelete);
                      }

                      let payload = {
                        "id": root_.getLms.id,
                        "book": book.book
                      }

                      root_.$store.dispatch("Whiteboard/updateSelectedBook", payload);
                    })
                    .finally(() => {
                      // clearInterval(root_.timerThumbnail); // Use to save once
                    });
              })
              .finally(() => {
                root_.whiteboardUserClick = false;
              });
        }

      }, root_.thumbnailDelayTime);


    },
    base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64.split(",")[1]);
      const length = binaryString.length;
      const bytes = new Uint8Array(length);

      for (let i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      return bytes;
    },
    selectPage(page) {
      let root_ = this;

      if(root_.selectedPage !== page.name) {

        root_.selectedPage = page.name;
        root_.whiteBoardRoom.setScenePath("/" + page.name);

        // if(page.ppt !)
        let cameraBound = {};
        if(page.ppt?.width) {
          cameraBound.width = page.ppt.width;
        }
        if(page.ppt?.height) {
          cameraBound.height = page.ppt.height;
        }

        root_.whiteBoardRoom.setCameraBound(cameraBound);

        // root_.whiteBoardRoom.setCameraBound({
        //   width: page.ppt.width,          // Largura máxima do quadro branco
        //   height: page.ppt.height         // Altura máxima do quadro branco
        // });



      }


    },
    toggleMenu(){
      this.dropdownPageToggle = !this.dropdownPageToggle;
    },
    undoStep() {
      this.whiteBoardRoom.undo();
    },
    redoStep() {
      this.whiteBoardRoom.redo();
    }
  },
  computed: {
    ...mapGetters("Whiteboard", [
        "getSelectedBook", "getBookCreatedNow"
    ]),
    ...mapGetters("LMS", [
        "getLms"
    ]),
    ...mapGetters(['checkMobile', 'checkIOS'])
  },
  beforeDestroy() {
    clearInterval(this.timerThumbnail);
  }
}


</script>

<style lang="scss">

section.whiteboard-section {

  margin-top: 6rem;
  height: 100vh;
  display: flex;
  align-items: flex-end;

  .container {
    height: 100%;
  }

  #dropdownPage {
    color: #706F6F;
    font-size: 16px;
    font-family: "Hanken Grotesk", sans-serif;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: left;
    background: #FFF;
    border: none;

  }

  .whiteboard-header-tools {

    background: #FCFCFC;
    width: 100%;
    height: 60px;
    border-top: 1px solid #E1E1E1;
    border-bottom: 1px solid #E1E1E1;

    .export-options {

      .format {
        color: #706F6F;
        font-family: Hanken Grotesk, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      #dropdownExport {
        color: #706F6F;
        font-size: 16px;
        font-family: "Hanken Grotesk", sans-serif;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-align: left;
        background: #FFF;
        border: none;
      }

      .system_update_alt {
        color: var(--buttons_color);
        text-align: center;
        font-family: Material Icons;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

    }

    .dark_mode {
      .material-icons-sharp {
        color: #706F6F;
        font-family: Material Icons;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .whiteboard-title {
      .title, input {
        color: #706F6F;
        leading-trim: both;
        text-edge: cap;
        font-family: Hanken Grotesk;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .edit, .done {
        color: var(--buttons_color);
        font-family: Material Icons;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        &:hover {
          cursor: pointer;
          color: #553ddb;
          transform: scale(1.1);
        }
      }

      #book-title-error {
        span {
          font-size: 14px;
        }

      }

    }

    .undo-redo {
      cursor: pointer;


      svg {
        width: 28px;
        height: 28px;
        fill: #B1B1B1;

        &.active {
          fill: var(--buttons_color);
          background-color: transparent;
        }

      }


    }



  }

  .board {
    height: 100%;
  }

}

#whiteboard {
  position: relative;
  width: 100%;
  height: 100%;
  background: #F0F0F0;
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.05);
}



 .link-record{
   cursor: pointer;
   outline: none;
   color:#4e73df;
   text-decoration:none;
   background-color:transparent
 }
.record-card .player-container{
  background: #c8c8c8;
}
.record-card .card{
  border: none;
}
.record-card .player-container i{
  border: 3px solid white;
  border-radius: 50%;
  padding: 20px 20px 20px 25px;
  font-size: 50px;
  background: #656565;
  color: white;
  top: 50%;
  transform: translateY(-50%);
}
.record-card .card-title{
  font-size: 1.5rem;
  font-weight: 700;
  color: #343434;
}
.microphone-mute{
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.line-top{
  display: none;
}
.close,.back{
  font-size: 2rem;
  font-weight: 100;
  opacity: 1!important;
}
.close:hover,.back:hover{
  opacity: 0.5!important;
}
.modal-title{
  font-size: 1.75rem;
  font-weight: 700;
}
.modal-body{
  color: #343434;
  width: 85%;
}
.general-content{
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #1f1f1f;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.player-container{
  width: 90%;
  padding-bottom: 60%;
  margin: 0 auto;
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  box-sizing: border-box;
}
.player-container .local,.player-container .remote{
  width: 100%;
  height: 100%;
  position: absolute;
}
.player-container .userImage{
  position: absolute;
  width: 100%;
  height: 100%;
  background: #c8c8c8;
}
.player-container .userImage .userImageContainer{
  position: absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 50%;
  padding-bottom: 50%;
  border-radius: 50%;
  overflow: hidden;
}
.userImage img{
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.userImage img[src=""]{
  display: none;
}
.openPlayer{
  position: absolute;
  top:10px;
  right: 5px;
}
.openPlayer .openPlayerBtn{
  width: 20px;
  height: 20px;
  position: absolute;
  text-align: center;
  right: 0;
  top:0;
}
.openPlayer .player{
  display: none;
}
.openPlayer .player.active{
  position: relative;
  top:20px;
  right: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  gap: 4px;
  border-radius: 10px;
  color: white;
  z-index:2;
  padding:5px;
}
.player label,.player .config,.player .playerOption{
  margin: 0;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px 10px;
  gap: 10px;
  color: #343434;
  text-align: initial;
  align-self: baseline;
  margin-left: 21px;
  line-height: 20px;
}
.player label input{
  display: none;
}
.player label img {
  opacity: 0.5;
}
.player label input:checked + img{
  opacity: 1;
}
.player .playerOption{
  border-bottom: 1px solid #e5e5e5;
}
.player .playerOption:last-child{
  border-bottom: none;
}
.player-container .name{
  position: absolute;
  bottom: 0;
  margin: 10px;
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}
.microphone.off .mic_on,.camera.off .cam_on{
  display: none;
}
.microphone:not(.off) .mic_off,.camera:not(.off) .cam_off{
  display: none;
}
.camera-preview,.preview-video{
  width: 100%;
  height: 100%;
  position: absolute;
  background: black;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch-label{
  margin-left: 5px;
  cursor: pointer;
  color: #686C7C;
}
.switch-label.active{
  color: var(--buttons_color);
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #eeeeee;
  border: 1px solid#AFB7D7;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 68px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 50%;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
}
input:checked + .slider {
  background-color: var(--buttons_color);
}
input:focus + .slider {
  box-shadow: 0 0 1px var(--buttons_color);
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.botao.azul{
  background: var(--buttons_color);
  color: var(--fonts_color);
}
.botao.cinza{
  background: var(--buttons_color_2nd);
  color: var(--fonts_color_2nd);
}

.whiteboard-header{
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.whiteboard-header .whiteboard-title{
  padding: 0 10px;
  font-size: 2rem;
  line-height: 1;
  font-weight: bold;
  color: #fff;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whiteboard-header .whiteboard-options{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  margin: 0 27px 0 10px;
  position: relative;
  line-height: 1;
}
.whiteboard-header .whiteboard-options>div,.whiteboard-option{
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 5px;
  width: 150px;
  font-size: 13px;
  margin-bottom: 0;
}
.whiteboard-body{
  width: 100%;
  height: calc(100% - 50px);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.whiteboard-content{
  position: absolute;
  width: calc(80% - 20px);
  height: 94%;
  left: 10px;
  overflow: hidden;
  padding: 10px 0 20px;
}
.whiteboard-content .download{
  cursor: pointer;
}

.whiteboard-content .player.active{
  border: 1px solid #ddd;
  box-shadow: 0px 0px 10px #ddd;
  top:30px !important;
  right:18px !important;
}

.whiteboard{
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
}
#btn-fullscreen{
  margin-left:50px;
}
.btn-fullscreen svg{
  margin-right:5px;
}

.whiteboard-content .btn-fullscreen{
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.whiteboard-content.full .whiteboard-title{
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 2rem;
  font-weight: bold;
  color:#343434;
}
.whiteboard-content .whiteboard-title,.whiteboard-content .recording,.whiteboard-content .download{
  display: none;
}
.whiteboard-content.full .whiteboard-title,.whiteboard-content.full .recording,.whiteboard-content.full .download{
  display: flex;
  align-items: center;
}
.whiteboard-content.full .btn-fullscreen .fullScreen{
  display: none;
}
.whiteboard-content:not(.full) .btn-fullscreen .exitFullScreen{
  display: none;
}
.toolbar{
  position: absolute;
  z-index: 99;
  border-left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 5px 5px;
  background: #f0f0f0;
  left: 10px;
}

.toolbar .whiteboard-tools, .whiteboard-tools-toggle{
  width: 42px;
  height: 42px;
  padding: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  outline: none;
  position: relative;

}
.available-tools-toggle{
  width: 60px;
  height: 50px;
  padding: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  margin: 20px 65px;
  outline: none;
  position: relative;
}

.available-tools-toggle svg {
  width: 100%;
  height: 100%;
  position: absolute;
  left:-72px;
}
.toolbar .whiteboard-tools svg,.whiteboard-tools-toggle svg{
  width: 100%;
  height: 100%;
}
.color-picker-label{
  position: absolute;
  right: 5px;
  bottom: 5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
#color-picker{
  opacity: 0;
  position: absolute;
  bottom: 0;
}
.camera-content{
  position: absolute;
  width: calc(20% - 10px);
  height: 94%;
  right: 10px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
}
.camera-content::-webkit-scrollbar{
  width: 10px;
}
.camera-content::-webkit-scrollbar-track{
  background: transparent;
}
.camera-content::-webkit-scrollbar-thumb{
  background: var(--buttons_color);
  border-radius: 10px;
}
.backMenuCortain{
  display:none;
  background-color:transparent;
  position:fixed;
  top:0px;
  left:0px;
  width:100%;
  height:100%;
  z-index:1
}
.downloadMenu_loading{
  display:none;
  padding:10px 60px;
  text-align:center;
}
.downloadMenu_loading img {
  width:30px;
}
.playerTools{
  position: relative;top:0;right: 0
}
.playerTools .openPlayerBtn{
  width: 150px;height: auto;position: relative;gap: 5px;text-align: start;font-size:13px;
}
.playerTools .player.active{
  position: absolute;width: auto;top: 30px;
}
.whiteboard-option-icon{
  color: white;
  font-size: 1.5rem;
}
.available_tools {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 20px 0px;
  padding: 0px 0px 0px 70px;
}
.ok_button {
  padding: 10px 47px;
  background-color: var(--buttons_color);
  color: var(--fonts_color);
  border-radius: 10px;
  margin: 5% 38%;
}
.svg_options {
  position: absolute;
  left: 12px;
}
#recordStatus{
  position: absolute;
  left: 10px;
  bottom: 10px;
  color: white;
}
#recordStatus i{
  color: red;
}
.share-options {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  padding: 10px 15px;
  width: 250px;
}
.share-options svg {
  cursor: pointer;
}
.mic_off {
  display: none;
}
#qr_code {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}
#modal_qrcode{
  z-index: 9999;
  background: rgba(0,0,0,0.5);
}

@media only screen and (max-width: 768px) {

  .toolbar {
    top: 25% !important;
  }

}

</style>